import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "../../../helpers/classNames";
const Container = ({ children, className, focusKey, }) => {
    return (_jsx("div", { className: classNames("mx-auto max-w-7xl sm:px-6 lg:px-8", className), "editor-focuskey": focusKey, children: children }));
};
export default Container;
//# sourceMappingURL=Container.js.map